import { gql } from "apollo-boost";

export const DATA_CENTERS = gql`
  query centers($where: CenterWhereInput) {
    centers(where: $where) {
      id
      name
      code
      email
      phone
      contact
      address
      enabled
      sectorId
      provinceId
      municipalityId
    }
  }
`;

export const UPDATE_CENTER = gql`
  mutation updateStateCenter($data: updateStateCenterInput) {
    updateStateCenter(data: $data)
  }
`;

export const GET_CHANNEL_BY_PROFILE = gql`
  query channelByProfile($where: channelByProfileInput) {
    channelByProfile(where: $where) {
      id
      name
    }
  }
`;

export const GET_DATA_MEDICAL_STAFF_PROVIDERS = gql`
  query medicalStaffProviders($where: MedicalStaffProviderWhereInput) {
    medicalStaffProviders(where: $where) {
      id
      providerId
      medicalStaffId
      profileId
      enabled
      profile {
        id
        name
        isAdmin
      }
      pharmacyProvider {
        id
        name
        commercialName
        phone
        contactName
        contactEmail
        provinceId
        municipalityId
        sectorId
        enabled
        address
        nif
        channelId
        legalPersonalityId
        printTypeId
        issueFiscalReceipts
        monthlyClosingDay
      }
      branchOfficeId
      branchOffice {
        id
        name
        email
        phone
        contact
        enabled
        address
        pharmacyProviderId
        provinceId
        municipalityId
        sectorId
        arses {
          id
          codePSS
          codePP
          codeUserPSS
          discountPP
          arsId
          branchOfficeId
          enabled
        }
      }
      isMedical
      userId
      user {
        id
        email
        profileId
        fullname
        username
        lastName
        firstName
        enabled
        isYourself
        identification
        documentTypeId
        profile {
          id
          name
          validateEmail
        }
      }
      medicalStaff {
        id
        name
        firstName
        middleName
        lastName
        lastName2
        username
        phone
        phone2
        cellphone
        email
        exequatur
        enabled
        identificationCard
        address
        municipalityId
        provinceId
        genderId
        sectorId
        legalPersonalityId
        userId
        medicalStaff {
          userId
          id
          providerId
          medicalStaffId
          profileId
        }
      }
    }
  }
`;

export const GET_PROFILES_CENTER = gql`
  query getProfilesByCenterId($where: ProfileByCenterInput) {
    profiles: getProfilesByCenterId(where: $where) {
      id
      name
      validateEmail
      enabled
      layoutsId
      emitsRecipe
    }
  }
`;

export const GET_ARSES = gql`
  query arses($where: ARSWhereInput) {
    arses(where: $where) {
      id
      name
      rnc
    }
  }
`;

export const UPDATE_BRANCH_OFFICE = gql`
  mutation UpdateBranchOffice(
    $where: BranchOfficeWhereInput
    $data: BranchOfficeInput
  ) {
    updateBranchOffice(where: $where, data: $data) {
      id
    }
  }
`;

export const SAVE_USER = gql`
  mutation SaveUser($data: SaveUserInput!) {
    saveUser(data: $data) {
      id
    }
  }
`;

export const SAVE_PHARMACY_PROVIDER = gql`
  mutation savePharmacyProvider($data: PharmacyProviderInput) {
    savePharmacyProvider(data: $data) {
      id
      name
    }
  }
`;

export const MEDICAL_STAFF_PROVIDERS_BY_USER = gql`
  query medicalStaffProvidersByUser($where: medicalStaffProvidersByUserInput) {
    medicalStaffProvidersByUser(where: $where) {
      centerId
      centerName
      contactName
      phone
      contactEmail
      enabled
      printTypeId
    }
  }
`;

export const SAVE_BRANCH_USER = gql`
  mutation saveBranchUser($data: saveBranchUserInput!) {
    saveBranchUser(data: $data) {
      errorOccurred
      errorCode
      errorMessage
      observation
    }
  }
`;

export const SET_BRANCH_USER_ENABLED = gql`
  mutation setBranchUserEnabled($data: setBranchUserEnabledInput!) {
    setBranchUserEnabled(data: $data) {
      errorOccurred
      errorCode
      errorMessage
      observation
    }
  }
`;

export const SAVE_BRANCH_USER_AND_MEDICAL = gql`
  mutation saveBranchUserAndMedical($data: saveBranchUserAndMedicalInput) {
    saveBranchUserAndMedical(data: $data) {
      errorOccurred
      errorCode
      errorMessage
      observation
    }
  }
`;

export const CREATE_ASSOCIATED_DOCTOR_PREREGISTRATION = gql`
  mutation createAssociatedDoctorPreregistration($data: AssociatedDoctorPreregistrationInput!) {
    createAssociatedDoctorPreregistration(data: $data) {
      id
      status
      requestedProfileId
      requestedProviderId
      requestedBranchOfficeId
      createdAt
    }
  }
`;


export const GET_PRINT_TYPES = gql`
  query getPrintType($where: PrintTypeI, $relations: [String]) {
    getPrintType(where: $where, relations: $relations) {
      id
      name
    }
  }
`;

export const GET_BRANCH_PREREGISTRATIONS = gql`
  query branchPreregistrations($where: MedicalPreregistrationWhereInput) {
    medicalPreregistrations(where: $where) {
      id
      firstName
      middleName
      lastName
      lastName2
      identificationCard
      documentType
      requestedProfileId
      status
      statusCode
      rejectionReason
      updatedAt
    }
  }
`;

// Consulta todas las sucursales del consultorio, sin depender de las
// sucursales asignadas al usuario, para validar nombres repetidos.
export const GET_PROVIDER_BRANCH_NAMES = gql`
  query providerBranchNames($where: BranchOfficeWhereInput) {
    branchOffices(where: $where) {
      id
      name
    }
  }
`;
